
export function ofEnforcedType<T>(obj: unknown) {
  return obj as T;
}
